import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/close_btn.svg';
const CloseIcon = (props) => React.createElement(IconSvg, Object.assign({}, props));
export default CloseIcon;
